import styled from 'styled-components';
import { hideScrollbar, mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  padding: var(--space-400);
  border-top: 1px solid var(--border-secondary);
  border-bottom: 1px solid var(--border-secondary);

  ${mediaQueries.tablet} {
    padding: var(--space-500);
    border: 1px solid var(--border-secondary);
    border-radius: var(--radius-brand);

    transition: border-color var(--motion-duration-100) var(--motion-ease-in-out);

    &:hover {
      border-color: var(--border-secondary-hover);
    }
  }
`;
export const Header = styled.header `
  margin-bottom: var(--space-300);

  display: flex;
  justify-content: space-between;
  gap: var(--space-200);

  ${mediaQueries.tablet} {
    margin-bottom: var(--space-500);
  }
`;
export const HeaderLeft = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${mediaQueries.tablet} {
    flex-direction: row;
    gap: var(--space-300);
  }
`;
export const Heading = styled.h3 `
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-400);
  text-wrap: balance;

  ${mediaQueries.tablet} {
    font-size: var(--font-size-500);
    line-height: var(--font-line-height-300);
  }
`;
export const Slider = styled.div `
  padding-left: var(--space-300);
  padding-right: var(--space-300);
  margin-left: var(--space-n300);
  margin-right: var(--space-n300);
  margin-bottom: -3px; // to make outline visible

  display: flex;
  gap: var(--space-400);

  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: var(--space-300);

  ${hideScrollbar};

  ${mediaQueries.tablet} {
    padding-left: var(--space-500);
    padding-right: var(--space-500);
    margin-left: var(--space-n500);
    margin-right: var(--space-n500);

    gap: var(--space-1000);

    scroll-padding-inline: var(--space-500);
  }
`;
export const Slide = styled.div `
  padding-bottom: 3px; // to make outline visible

  flex: 0 0 100%;
  display: flex;
  gap: var(--space-300);

  scroll-snap-align: start end;

  ${mediaQueries.tablet} {
    flex: 0 0 calc((100% / 3) - (80px / 3));
  }
`;
export const Thumbnail = styled.img `
  display: block;
  width: 48px;
  height: 48px;
  object-fit: contain;
`;
export const Name = styled.div `
  margin-bottom: var(--space-100);

  color: var(--text-primary);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-400);
  text-wrap: balance;
`;
export const Description = styled.div `
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
  min-height: 3em;
  text-wrap: balance;
`;
export const Buttons = styled.div `
  margin-top: var(--space-300);

  display: flex;
`;
export const Signet = styled.img `
  display: block;
  width: 12px;
  height: 12px;
  object-fit: contain;
`;
